/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import { withAppContext, getToken } from '@ctsu/loader';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import bindLogger from 'helpers/BindLogger';
import { DocumentHelper, Modal } from '@ctsu/react-ctsu-ui';
import { ATCONSTANTS as ATC } from 'appconstants';
import { FasLayerGroup } from 'assets/icons';
import { getSupportDocs } from 'actions/packet';

const FILE_POPUP_COLOUMN = [
  { name: 'sectionSubHeading', label: 'Document Type' },
  {
    name: 'documentFileName',
    label: 'Document Filename',
    renderCell: (row) => (
      <DocumentHelper
        docId={row.docId}
        type="text"
        icon="pdf"
        docContext="EDK"
        docFileName={row.documentFileName}
        getToken={getToken}
        appName={process.env.REACT_APP_NAME}
      />
    )
  }
];

function DocumentComponent({ rdmId, fileName }) {
  if (rdmId) {
    return (
      <DocumentHelper
        docId={rdmId}
        type="icon"
        icon={fileName != null && fileName.toLowerCase().endsWith('.pdf') ? 'pdf' : 'file'}
        docContext="IMAGEREP"
        docFileName={fileName || 'No File Name'}
        getToken={getToken}
        appName={process.env.REACT_APP_NAME}
      />
    );
  }
  return null;
}

function SupportingDocDowload({ context, packet, allowMultiDoc = true }) {
  const {
    rdmId, packetId, packetType, id, fileName
  } = packet;
  const [showMultiDocPopup, setShowMultiDocPopup] = useState(false);
  const [multiDocRows, setMultiDocRows] = useState([]);

  const getSupportDoc = () => {
    if (allowMultiDoc) {
      bindLogger(
        getSupportDocs,
        context
      )(packetId).subscribe((resp) => {
        setShowMultiDocPopup(true);
        setMultiDocRows(resp);
      });
    }
  };

  const onClose = () => {
    setShowMultiDocPopup(false);
  };

  return (
    <>
      {packetType === 'WEB_SERVICE' ? (
        <button
          type="button"
          className="fn-btn mr-1"
          data-id={`${ATC.PACKETID}${id}_PACKET_DOCUMENTS${ATC.BUTTON}`}
          onClick={getSupportDoc}
          disabled={!allowMultiDoc}
          title={
            allowMultiDoc ? 'Packet Documents' : 'Please open it from Packet main grid to load all Web Services Docs'
          }
        >
          <FasLayerGroup />
        </button>
      ) : (
        <DocumentComponent rdmId={rdmId} fileName={fileName} />
      )}
      {showMultiDocPopup ? (
        <Modal id="supporting-docs" modalTitle="Packet Documents" onClose={onClose} showCloseBtn>
          <div className="card-body dialogBody">
            <div className="row">
              <div data-id={`${ATC.APP}MESSAGE_TEXT{ATC.DIV}`} className="col-12 message" data-testid="message">
                <div className="col-12">
                  <GridTable
                    tag={`${ATC.PACKETID}FILE_GRID${ATC.TABLE}`}
                    id="fileGrid"
                    rows={multiDocRows}
                    columns={FILE_POPUP_COLOUMN}
                    getToken={getToken}
                  // toPdf={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
}

export default withAppContext(SupportingDocDowload);
